
export default {
  name: 'FontPicker',
  props: {
    value: {},
  },
  data() {
    return {
      selectedFont: 'Arial',
      fonts: [
        'Arial',
        'Avenir',
        'CashSans',
        'Verdana',
        'Helvetica',
        'Tahoma',
        'Trebuchet MS',
        'Times New Roman',
        'Georgia',
        'Garamond',
        'Courier New',
        'Brush Script MT',
        'Segoe UI',
        'Roboto',
        'Open Sans',
        'Montserrat',
        'Lato',
        'Poppins',
        'Merriweather',
        'Playfair Display',
        'Raleway',
        'Source Code Pro',
        'Dancing Script',
        'Bebas Neue',
        'Caveat',
        'Sora',
        'DM Sans',
      ],
    }
  },

  computed: {
    sortFonts() {
      return this.fonts.sort()
    },
  },
  methods: {
    updateFont(event) {
      this.$emit('input', event.target.value)
    },
  },
}
